import { useState } from "react";
import { Menu, X } from "lucide-react";

const links = [
  { id: "about", label: "About" },
  { id: "services", label: "Services" },
  { id: "process", label: "Process" },
  { id: "contact", label: "Contact" },
];

export default function Nav({ scrolled }) {
  const [open, setOpen] = useState(false);

  const handleClick = (id) => {
    setOpen(false);
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      data-testid="site-nav"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-black/60 backdrop-blur-2xl border-b border-white/5"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 h-16 md:h-20 flex items-center justify-between">
        <button
          data-testid="nav-home"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="flex items-center gap-3 group"
        >
          <span className="relative inline-flex h-7 w-7 items-center justify-center rounded-md bg-gradient-to-br from-violet-500 to-violet-800 shadow-[0_0_24px_-4px_rgba(139,92,246,0.6)]">
            <span className="font-display text-sm font-black text-white">M</span>
          </span>
          <span className="font-display text-base md:text-lg font-bold tracking-tight">
            Maximilian <span className="text-violet-400">Marketing</span>
          </span>
        </button>

        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-${l.id}`}
              onClick={() => handleClick(l.id)}
              className="nav-link font-mono-label text-[11px] text-white/60"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <a
          href="tel:+12013065226"
          data-testid="nav-cta-call"
          className="hidden md:inline-flex cta-pill items-center justify-center rounded-full px-5 py-2.5 text-sm font-semibold text-white"
        >
          Start a project
        </a>

        <button
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen((v) => !v)}
          className="md:hidden h-10 w-10 inline-flex items-center justify-center rounded-full border border-white/10 text-white"
          aria-label="Toggle menu"
        >
          {open ? <X size={18} /> : <Menu size={18} />}
        </button>
      </div>

      {open && (
        <div
          data-testid="nav-mobile-panel"
          className="md:hidden bg-black/90 backdrop-blur-xl border-t border-white/5"
        >
          <div className="px-6 py-6 flex flex-col gap-5">
            {links.map((l) => (
              <button
                key={l.id}
                data-testid={`nav-mobile-${l.id}`}
                onClick={() => handleClick(l.id)}
                className="text-left font-display text-2xl font-semibold text-white/90 hover:text-violet-400 transition-colors"
              >
                {l.label}
              </button>
            ))}
            <a
              href="tel:+12013065226"
              data-testid="nav-mobile-cta"
              className="cta-pill mt-2 inline-flex items-center justify-center rounded-full px-5 py-3 text-sm font-semibold text-white"
            >
              Start a project
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
